var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon24Formattextpoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-24-format_text_point",
    "data-name": "icon-24-format text point",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding_box",
    "data-name": "Bounding box",
    width: 24,
    height: 24,
    fill: "rgba(255,255,255,0)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_color",
    "data-name": "Icon color",
    d: "M17.5,14H4.5a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5h13a.5.5,0,0,1,.5.5v1A.5.5,0,0,1,17.5,14Zm-16,0H.5a.5.5,0,0,1-.5-.5v-1A.5.5,0,0,1,.5,12h1a.5.5,0,0,1,.5.5v1A.5.5,0,0,1,1.5,14Zm16-6H4.5A.5.5,0,0,1,4,7.5v-1A.5.5,0,0,1,4.5,6h13a.5.5,0,0,1,.5.5v1A.5.5,0,0,1,17.5,8ZM1.5,8H.5A.5.5,0,0,1,0,7.5v-1A.5.5,0,0,1,.5,6h1a.5.5,0,0,1,.5.5v1A.5.5,0,0,1,1.5,8Zm16-6H4.5A.5.5,0,0,1,4,1.5V.5A.5.5,0,0,1,4.5,0h13a.5.5,0,0,1,.5.5v1A.5.5,0,0,1,17.5,2ZM1.5,2H.5A.5.5,0,0,1,0,1.5V.5A.5.5,0,0,1,.5,0h1A.5.5,0,0,1,2,.5v1A.5.5,0,0,1,1.5,2Z",
    transform: "translate(3 5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon24Formattextpoint);
export default __webpack_public_path__ + "static/media/icon-24-format text point.ff15a5941c52798ecc8ac2ea1a1c0986.svg";
export { ForwardRef as ReactComponent };